// extracted by mini-css-extract-plugin
export default {"h2":"WorkOnMobile_h2__QRyL5","container":"WorkOnMobile_container__h2mu6","blocksMobile":"WorkOnMobile_blocksMobile__RTDY4","itemBlocksMobile":"WorkOnMobile_itemBlocksMobile__PYjzp"};